import React, { useState } from "react";

export default function Analytics() {
  const [formData, setFormData] = useState({
    traffic_count: "",
    area_housing_value: "",
    hotels_in_vicinity_halfmile: "",
    hotels_in_area_3mile: "",
    workplace_density: "",
    working_age_population: "",
    economic_vitality_index: "",
    percent_workers_key_industries: "",
    income_around_site: "",
    population_density: "",
  });
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    try {
      const res = await fetch("/api/predict", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (res.ok) {
        setResult(data.predicted_revenue);
      } else {
        setError(data.error || "An error occurred");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "600px", margin: "0 auto" }}>
      <h1>Revenue Prediction Tool</h1>
      <form onSubmit={handleSubmit}>
        {Object.keys(formData).map((key) => (
          <div key={key} style={{ marginBottom: "10px" }}>
            <label style={{ textTransform: "capitalize" }}>
              {key.replaceAll("_", " ")}:
            </label>
            <input
              name={key}
              value={formData[key]}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "6px", borderRadius: "4px" }}
            />
          </div>
        ))}
        <button type="submit" style={{ padding: "10px 15px" }}>
          Predict
        </button>
      </form>
      {result && (
        <h2 style={{ marginTop: "20px" }}>
          Predicted Revenue: ${Number(result).toLocaleString()}
        </h2>
      )}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
    </div>
  );
}
